import { gsap, SplitText, ScrollTrigger } from '../../global/gsap';

const initHomeHero = (section) => {
    const body = document.querySelector('body');
    body.classList.add('stop-scrolling');
    const text = section.querySelector('.js-home-hero-text');
    const initialText = section.querySelector('p');
    const logoRoot = section.querySelector('.js-home-hero-logo');
    let logoHeight = logoRoot.offsetHeight;
    const logo = gsap.utils.toArray('.js-home-hero-logo path');
    const header = document.querySelector('.js-header');
    logo.reverse();

    let mm = gsap.matchMedia();

    let readyToPlay = false;

    const split = new SplitText(text, { type: 'words' });
    const words = split.words;

    const initialTl = gsap.timeline({defaults: {
        ease: 'power3.inOut',
        duration: .75
    }});

    const wordsTl = gsap.timeline({defaults: {
        ease: 'power3.inOut',
        duration: .5
    }});

    const menuTransitionTl = gsap.timeline(
        ScrollTrigger.create({
            trigger: section,
            start: `bottom top`,
            onEnter: () => {
                body.classList.add('passed-hero');
            },
            onEnterBack: () => {
                body.classList.remove('passed-hero');
            }
        })
    );


    wordsTl.pause();

    gsap.set(initialText, {autoAlpha: 0, yPercent: 40});
    gsap.set(logo, {autoAlpha: 0, yPercent: 40});
    gsap.set(words, {autoAlpha: 0, yPercent: 60});

    initialTl.to(initialText, {autoAlpha: 1, yPercent: 0})

    initialTl.to(logo, {
        autoAlpha: 1,
        yPercent: 0,
        stagger: .1,
        duration: .5,
        onComplete: () => {
            body.classList.remove('stop-scrolling');
            readyToPlay = true;
        }
    })

    wordsTl.to(words, {
        autoAlpha: 1,
        stagger: 0.05,
        yPercent: 0,
        onComplete: () => {
            // gsap.to(header, {opacity: 1, yPercent: 0});
            body.classList.add('has-scrolled');
            
        }
    });

    window.addEventListener('scroll', () => {
        if(readyToPlay) {
            wordsTl.play();
        }
    });

    mm.add("(max-width: 899px)", () => {
        setTimeout(() => {
            console.log('timerUp');
            body.classList.add('has-scrolled');
            wordsTl.play();
        }, 4000)
    });

    window.addEventListener('DOMContentLoaded', () => {
        document.body.style.setProperty("--heroLogoHeight", `${logoHeight}px`);
    })

    window.addEventListener('resize', () => {
        document.body.style.setProperty("--heroLogoHeight", `${logoHeight}px`);
    })

    window.addEventListener('DOMContentLoaded', () => {
        window.scrollTo(0, 0);
    })

};

export default initHomeHero;
